import { Component } from '@ecs/Component';

export type EntityTag = 'player' | 'enemy' | 'bullet' | 'particle' | 'torpedo' | 'mine';

export class Tag implements Component {
  readonly type = 'Tag';

  constructor(
    public value: EntityTag
  ) {}
}